// extracted by mini-css-extract-plugin
module.exports = {"team_table_container":"team_box_sort-module--team_table_container--2GIaT"};